/*
 * convert select data structure to value for each field -
 * Takes formValue (formGroup.getRawValue()) and selectDataFields ['name']
 * Usage:
 *   const form = { ...getSelectDataValues(form.getRawValue(), ['name']) };
 * Example:
 *   getSelectDataValues(form.getRawValue(), ['name'])
 *   { name: 'name1' }
 */

//alterei a função para lidar com objetos passados com . como 'regras.nomeRegra'
export function getSelectDataValues(
  formValue: any,
  selectDataFields: string[]
): any {
  selectDataFields.forEach((fieldPath: string) => {
    const keys = fieldPath.split('.');
    let current = formValue;

    // Navega até o penúltimo nível
    for (let i = 0; i < keys.length - 1; i++) {
      if (current[keys[i]] == null) return; // ignora se o caminho não existir
      current = current[keys[i]];
    }

    const lastKey = keys[keys.length - 1];
    const raw = current?.[lastKey];

    current[lastKey] =
      raw && typeof raw === 'object' && 'value' in raw ? raw.value : raw ?? null;
  });

  return formValue;
}

//não conseggui alterar essa função para que pegasse o valor sozinho e encapsulasse em um objeto.
//Em todas as minhas tentativas, a função dava errado e não aparecia nenhuma label no campo.
export function getSelectDataObjectValues(
  response: any,
  selectDataFields: string[]
): any {
  selectDataFields.forEach((field: string) => {
    response[field] = response[field] ? { value: response[field], label: response[field] } : null;
  });
  return response;
}

export function extractSelectValue<T = number | string>(selectField: unknown): T | null {
  if (selectField === null || selectField === undefined || selectField === '') {
    return null;
  }

  if (typeof selectField === 'object' && selectField !== null && 'value' in selectField) {
    return (selectField as { value: T | null }).value ?? null;
  }

  if (typeof selectField === 'number' || typeof selectField === 'string') {
    return selectField as T;
  }

  return null;
}
